import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InfrastructureIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.75 6.25007C3.75 6.91313 4.4085 7.54904 5.58064 8.01789C6.75277 8.48675 8.34253 8.75015 10.0002 8.75015C11.6578 8.75015 13.2476 8.48675 14.4197 8.01789C15.5919 7.54904 16.2504 6.91313 16.2504 6.25007C16.2504 5.58701 15.5919 4.95111 14.4197 4.48225C13.2476 4.0134 11.6578 3.75 10.0002 3.75C8.34253 3.75 6.75277 4.0134 5.58064 4.48225C4.4085 4.95111 3.75 5.58701 3.75 6.25007Z",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.75 6.25V9.99955C3.75 11.3802 6.54842 12.4996 10.0002 12.4996C13.452 12.4996 16.2504 11.3807 16.2504 9.99955V6.25",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.75 9.99951V13.7496C3.75 15.1302 6.54842 16.2497 10.0002 16.2497C13.452 16.2497 16.2504 15.1302 16.2504 13.7496V9.99951",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
